<script>
  export default {
    props: {
      list: {
        type: Array,
        default: () => {
          return [
            {
              text: '標題',
              to: 'home' // routeName
            }
          ]
        }
      },
    },
  }
</script>
<template>
  <ul :class="$style.subNav">
    <li
      v-for="(item, index) in list"
      :key="index"
      class="subNav__item"
    >
      <template v-if="item.type === 'link'">
        <a
          class="subNav__link"
          :href="item.path"
          target="_blank"
        >
          {{ item.text }}
        </a>
      </template>
      <template v-else>
        <router-link
          class="subNav__link"
          :to="item.to"
        >
          {{ item.text }}
          <i
            v-if="item.children && item.children.length > 0"
            class="fal fa-chevron-right ml-3"
          ></i>
        </router-link>
      </template>
      <ul
        v-if="item.children && item.children.length > 0"
        class="subNav__subNav"
      >
        <li
          v-for="(itemChildren, index2) in item.children"
          :key="index2"
          class="subNav__subNav__item"
        >
          <template v-if="itemChildren.type === 'link'">
            <a
              class="subNav__subNav__link"
              :href="itemChildren.path">
              {{ itemChildren.text }}
            </a>
          </template>
          <template v-else>
            <router-link
              class="subNav__subNav__link"
              :to="itemChildren.to"
            >
              {{ itemChildren.text }}
            </router-link>
          </template>
        </li>
      </ul>
    </li>
  </ul>
</template>
<style lang="scss" module>
  .subNav {
    @include list-unstyled;

    position: absolute;
    bottom: 1px;
    left: 50%;
    padding: 1rem 2rem;
    pointer-events: none;
    background: #FFF;
    box-shadow: 0 10px 20px #21455827;
    opacity: 0;
    transition: opacity 0.3s;
    transform: translate(-50%, 100%);

    @include max-xl {
      padding: 1rem 1.5rem;
      font-size: 1rem;
    }

    :global {
      .subNav {
        &__item {
          position: relative;

          &:hover {
            .subNav {
              &__link {
                color: $color-gray-6;
                font-weight: 500;
                text-decoration: none;
              }
            }

            &:hover {
              .subNav {
                &__subNav {
                  opacity: 1;
                }
              }
            }
          }
        }

        &__link {
          display: block;
          padding: 0.5rem 0;
          color: $color-gray-5;
          white-space: nowrap;

          &.router-link-active {
            color: $color-gray-6;
            font-weight: 500;
            text-decoration: underline !important;
          }
        }

        &__subNav {
          @include list-unstyled;

          position: absolute;
          top: 0;
          right: -2rem;
          z-index: 1;
          padding: 1rem 2rem;
          background: #FFF;
          box-shadow: 0 10px 20px #21455827;
          opacity: 0;
          transition: opacity 0.3s;
          transform: translateX(100%);

          @include max-xl {
            right: 1rem;
            padding: 1rem 1.5rem;
            font-size: 1rem;
          }

          &__item {
            position: relative;
          }

          &__link {
            display: block;
            padding: 0.5rem 0;
            color: $color-gray-5;
            white-space: nowrap;

            &:hover {
              color: $color-gray-6;
              font-weight: 500;
              text-decoration: none;
            }

            &.router-link-active {
              color: $color-gray-6;
              font-weight: 500;
              text-decoration: underline !important;
            }
          }
        }
      }
    }
  }
</style>
